import type { ReactNode } from 'react';
import styles from './Label.module.css';

export type LabelVariant =
  | 'gray'    // フリープラン、デフォルト
  | 'blue'    // プラスプラン
  | 'purple'  // ビジネスプラン
  | 'gold'    // エンタープライズプラン
  | 'orange'  // エージェンシー
  | 'green'   // 有効、アクティブ
  | 'yellow'  // 一時停止、警告
  | 'red';    // キャンセル、エラー

export interface LabelProps {
  variant?: LabelVariant;
  children: ReactNode;
  className?: string;
}

export function Label({
  variant = 'gray',
  children,
  className = '',
}: LabelProps) {
  const variantClass = `label--${variant}`;

  const combinedClassName = [
    styles.label,
    styles[variantClass],
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <span className={combinedClassName}>
      {children}
    </span>
  );
}
